<template>
  <div
    class="main-box"
    v-bind="$attrs"
  >
    <div
      v-if="customer"
      :class="`pt-2 px-1 pb-1 rounded-md transition-all card-box active color-${color}`"
      @click="clickCustomer(customer)"
    >
      <div class="h-32 flex gap-5 items-center px-2" style="height: calc(100% - 38px);">
        <div class="rounded-circle bg-white d-flex justify-center align-center" style="height: 100px; width: 100px; overflow: hidden;">
          <img 
            :src="customer && customer.profileImages && customer.profileImages[0] ? customer.profileImages[0].url : '/user.png'"
            style="width: 100%;"
          />
        </div>
        <div>
          <div class="font-bold">
            {{ $t('market.customer_name_and_company') }} :
            <span class="mb-1 font-medium">{{ customer.fullName || '-' }}</span>
          </div>
  
          <div class="font-bold">
            {{ $t('account.phone_number') }} :
            <span class="mb-1 font-medium">{{ customer.fullTels || '-' }}</span>
          </div>
  
          <div class="font-bold">
            {{ $t('account.email_address') }} :
            <span class="mb-1 font-medium">{{ customer.fullEmails || '-' }}</span>
          </div>
        </div>
      </div>
      <div class="footer-box black--text">
        <hr style="border-top: 1px solid white;" class="my-1" />
        <div class="items-center bg-white text-center py-1 rounded-b-md">
          <div class="font-bold">
            {{ $t('customer.customer_type') }}
            <span class="mb-1 font-medium">{{ typeString[customer.type] || '-' }}</span>
          </div>
        </div>
      </div>
    </div>
    <div v-else
      class="d-flex justify-center align-center pt-2 px-1 pb-1 rounded-md transition-all card-box select-box"
      @click="isSelectCustomerDialog = true"
    >
      <h4 class="grey--text">{{ $t('customer.select_customer') }} <span class="red--text">*</span></h4>
    </div>

    <SelectCustomer
      v-model="isSelectCustomerDialog" 
      @select="selectCustomer" 
      :header="$t('customer.select_customer')"
    />
  </div>
</template>

<script>
import SelectCustomer from './SelectCustomer.vue';
export default {
  props: {
    customer: Object,
    marketId: String,
    projectId: String,
    color: String
  },
  components: {
    SelectCustomer
  },
  data() {
    return {
      isSelectCustomerDialog: false,
      typeString: {
        personal: "",
        company: ""
      }
    }
  },
  created() {
    this.typeString.personal = this.$t('customer.type.personal');
    this.typeString.company = this.$t('customer.type.company');
  },
  methods: {
    selectCustomer(customer){
      this.$emit("onSelectCustomer", customer)
      this.isSelectCustomerDialog = false
    },
    clickCustomer(customer) {
      window.open(`/project/${this.projectId}/market/${this.marketId}/customer/${customer.objectId}/view`, "_blank")
    }
  }
}
</script>
<style lang="scss" scoped>
.card-box {
  height: 100%;
  background-color: none;
  position: relative;
  cursor: pointer;
  background-color: rgba(128, 128, 128, 0.04);
  &:hover {
    background-color: rgba(128, 128, 128, 0.07);
  }
  &.active {
    background-color: rgba(224, 247, 233, 1);
    color: var(--default-green) !important;
    font-size: 14px;
    &:hover {
      background-color: rgb(212, 244, 224);
    }
    &.color-info {
      background-color: rgba(0, 156, 229, 0.1);
      color: var(--default-blue) !important;
      &:hover {
        background-color: rgba(0, 156, 229, 0.2);
      }
    }
  }
}
</style>